export const playSound = (correct: boolean) => {
  const AudioContext =
    window.AudioContext ||
    (window as any).webkitAudioContext;

  const ctx = new AudioContext();

  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();

  oscillator.connect(gain);
  gain.connect(ctx.destination);


  if (correct) {
    // success sound (high pitch)
    oscillator.frequency.value = 880;
    gain.gain.value = 0.15;

    oscillator.start();

    setTimeout(() => {
      oscillator.frequency.value = 1200;
    }, 120);

  } else {
    // wrong sound (low pitch)
    oscillator.frequency.value = 220;
    gain.gain.value = 0.2;

    oscillator.start();
  }


  oscillator.stop(
    ctx.currentTime + 0.25
  );
};